
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|2476|2964|4086)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
